module.exports = __webpack_public_path__ + "static/media/users.70a90bfb.svg";